<template>
    <div>
        <LoaderVue v-if="logging" />
        <div v-else>
            You are logged out. Please sign in from cta portal
        </div>
    </div>
</template>

<script>

import LoaderVue from '@/components/common/Loader.vue'
export default {
    data () {
        return {
            logging: true
        }
    },
    components: {
        LoaderVue
    },
    async mounted () {
        if (this.$route.params.token) {
            const resp = await this.$store.dispatch('Auth/Signin/signIn', { token: this.$route.params.token })
            if (resp && resp.data.token) {
                this.$router.push('/')
            } else {
                this.logging = false
                await this.$store.dispatch('unsetUser')
                this.$router.push('/signin')
            }
        } else {
            if (localStorage.token) {
                this.logging = true
                this.$router.push('/')
            } else {
                this.logging = false
                await this.$store.dispatch('unsetUser')
            }
        }
    }
}
</script>

<style>

*{
  border: 0px;
  padding: 0px;
  margin: 0px;
}
#main {
  background-color: black;
  width:100vw;
  height: 100vh;
  display: flex;
}

</style>
